import * as Sentry from '@sentry/react'
import { env, isRunningLocally } from 'src/helpers'

const environment =
  env('cognito_client') === '1v2m1ihhl2a3dbdhpue48c66uj' ? 'dev' : 'prod'
const service = `web-${environment}`
const isLocal = isRunningLocally()

interface LogMessage {
  message: string
  level: string
  module: string
  data?: object
  error?: any
  time?: number
}

const staticMetadata = {
  service,
  userId: undefined as string | undefined,
  host: 'app',
}

export const identifySentry = (
  userId: number,
  email?: string,
  firstName?: string,
  lastName?: string,
) => {
  try {
    staticMetadata.userId = String(userId)
    // Set user in Sentry for error tracking
    if (!isLocal) {
      Sentry.setUser({
        id: String(userId),
        email: email,
        username:
          firstName && lastName ? `${firstName} ${lastName}` : undefined,
      })
    }
  } catch (error) {
    // Don't throw - let the app continue
  }
}

export const sendLog = ({
  message,
  level,
  module,
  data,
  error,
}: LogMessage) => {
  if (isLocal) return

  try {
    const context = {
      ...staticMetadata,
      module,
      ...data,
    }

    if (level === 'error') {
      // Capture errors/exceptions with Sentry
      if (error instanceof Error) {
        Sentry.captureException(error, {
          extra: { ...context, originalMessage: message },
          tags: { module, service },
        })
      } else {
        Sentry.captureMessage(message, {
          level: 'error',
          extra: context,
          tags: { module, service },
        })
      }
    } else if (level === 'warn') {
      Sentry.captureMessage(message, {
        level: 'warning',
        extra: context,
        tags: { module, service },
      })
    } else {
      // For info/debug logs, use Sentry's logger (requires enableLogs: true in init)
      // This sends to Sentry Logs product
      Sentry.logger.info(message, context)
    }
  } catch (err) {
    // Don't throw - let the app continue
  }
}
